<template>
  <v-card class="elevation-2">
    <v-card-title class="d-flex justify-space-between align-center">
      <span>Gestión de Torneos</span>
      <v-btn small color="primary" @click="$emit('refresh')">
        <v-icon small>mdi-refresh</v-icon>
        Actualizar
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>

      <div v-if="!loading && tournaments.length === 0" class="text-center py-8">
        <v-icon large color="grey lighten-1" class="mb-3">mdi-tournament</v-icon>
        <p class="grey--text">No hay torneos creados</p>
      </div>

      <v-data-table
        v-else
        :headers="headers"
        :items="tournaments"
        :loading="loading"
        hide-default-footer
        class="elevation-0"
      >
        <template #item.name="{ item }">
          <div>
            <div class="font-weight-bold">{{ item.name }}</div>
            <div class="text-caption grey--text">{{ item.created_by_display }}</div>
          </div>
        </template>

        <template #item.date="{ item }">
          {{ formatDate(item.start_date) }}
        </template>

        <template #item.players="{ item }">
          <v-progress-linear
            :value="getParticipationPercentage(item)"
            height="20"
            class="my-2"
            :color="item.is_full ? 'error' : 'primary'"
          >
            <template #default="{ value }">
              <span class="text-caption font-weight-bold white--text">
                {{ item.current_players }}/{{ item.max_players }}
              </span>
            </template>
          </v-progress-linear>
        </template>

        <template #item.status="{ item }">
          <v-select
            :value="item.status"
            :items="statusOptions"
            item-text="text"
            item-value="value"
            dense
            outlined
            hide-details
            @change="updateStatus(item, $event)"
            style="min-width: 150px"
          ></v-select>
        </template>

        <template #item.actions="{ item }">
          <v-menu offset-y small>
            <template #activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on">
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="$emit('view-registrations', item)">
                <v-list-item-icon>
                  <v-icon small>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Ver Inscritos</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('edit', item)">
                <v-list-item-icon>
                  <v-icon small>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="$emit('delete', item)">
                <v-list-item-icon>
                  <v-icon small>mdi-trash-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="error--text">Eliminar</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TournamentsManagement',
  props: {
    tournaments: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      headers: [
        { text: 'Nombre', value: 'name', sortable: false },
        { text: 'Fecha', value: 'date', sortable: false, width: '120px' },
        { text: 'Inscritos', value: 'players', sortable: false, width: '150px' },
        { text: 'Estado', value: 'status', sortable: false, width: '150px' },
        { text: 'Acciones', value: 'actions', sortable: false, width: '80px' }
      ],
      statusOptions: [
        { text: 'Pendiente', value: 1 },
        { text: 'Confirmado', value: 2 },
        { text: 'En curso', value: 4 },
        { text: 'Finalizado', value: 5 },
        { text: 'Cancelado', value: 6 }
      ]
    }
  },
  methods: {
    formatDate (date) {
      return new Date(date).toLocaleDateString('es-ES', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    },
    getParticipationPercentage (tournament) {
      return (tournament.current_players / tournament.max_players) * 100
    },
    async updateStatus (tournament, newStatus) {
      if (tournament.status === newStatus) return

      try {
        await this.$store.dispatch('tournaments/updateTournament', {
          id: tournament.id,
          data: { status: newStatus }
        })
      } catch (err) {
        // Error manejado en el store
      }
    }
  }
}
</script>

<style scoped>
::v-deep .v-data-table {
  background: transparent;
}

::v-deep .v-data-table__wrapper {
  padding: 0;
}

::v-deep .v-select {
  font-size: 14px;
}
</style>
